angular.module("app").directive("getTemplate", [
    '$compile',
    '$templateRequest',
    function ($compile, $templateRequest) {
        return {
            restrict : "E",
            replace: true,
            link: function (scope, element, attrs) {
                var templateToRender =
                    ((scope && scope.child && scope.child.value_type && scope.child.value_type.replace(/ /g, "")) || 'empty') + '.html';
                $templateRequest("views/templates/configs_templates/" + templateToRender).then(
                    function (html) {
                        var template = angular.element(html);
                        $(element).replaceWith(template);
                        $compile(template)(scope);
                    }
                )
            }
        }
    }
]);